import { create } from "zustand";
import { ModalAlertProps } from "@shared/src/components/common/misc/ModalAlert";
import { type ButtonProps } from "@shared/src/components/ui/button";
import { ModalAlertType } from "@sdk/shared/types/modal.types";
import { chains } from "@shared/src/config/chains";
import { useHostStore } from "./useHostStore";

const reset = {
  type: "info" as ModalAlertType,
  title: undefined,
  messageTitle: undefined,
  message: undefined,
  description: undefined,
  buttonText: undefined,
  buttonClick: undefined,
  autoClose: undefined,
  autoCloseDelay: undefined,
  preventClose: undefined,
  onOpenChange: undefined,
  open: false,
  buttonVariant: "primary" as ButtonProps["variant"],
  leftButtonText: undefined,
  leftButtonClick: undefined,
  leftButtonVariant: "surface-secondary" as ButtonProps["variant"],
  showLeftButton: false,
} satisfies ModalAlertProps;

export interface ModalStoreProps extends ModalAlertProps {
  showModal: (props: ModalAlertProps) => void;
  updateModal: (props: Partial<ModalAlertProps>) => void;
  closeModal: () => void;
  showNetworkMismatchModal: (correctNetworkId: number) => void;
  networkModalOpen: boolean;
  setNetworkModalOpen: (networkModalOpen: boolean) => void;
}

export const useModalStore = create<ModalStoreProps>((set, get) => ({
  networkModalOpen: false,
  setNetworkModalOpen: (networkModalOpen: boolean) => {
    set({ networkModalOpen });
  },
  isOpen: false,
  type: "info",
  showNetworkMismatchModal: (correctNetworkId: number) => {
    const correctNetwork = chains.find(c => c.id === correctNetworkId);

    get().showModal({
      type: "info",
      title: "Network mismatch",
      description: `Please switch to ${correctNetwork?.name} to continue`,
      buttonClick: async () => {
        await useHostStore.getState().setAndSwitchChain(correctNetworkId);
      },
      buttonText: "Switch Network",
    });
  },
  onOpenChange: () => {},
  showModal: (props: ModalAlertProps) => {
    set({
      ...reset,
      open: true,
      ...props,
    });
  },
  updateModal: (props: Partial<ModalAlertProps>) => {
    set({
      open: true,
      ...props,
    });
  },
  closeModal: () => {
    set({
      ...reset,
    });
  },
}));
